module.exports = __webpack_public_path__ + "img/ico-log-out.f2cc2413.svg";